module.exports = __webpack_public_path__ + "static/media/man_black.275bbc66.svg";